// extracted by mini-css-extract-plugin
export default {"container":"CardsContainer_container__OJ4SR","date":"CardsContainer_date__8afTN","date-container":"CardsContainer_date-container__A8qtk"};